import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'

interface AboutSectionProps {
  onCtaClick: () => void
}

const AboutSection = ({ onCtaClick }: AboutSectionProps) => {
  return (
    <section className="afterwork__about">
      <h1 className="afterwork__about-title">
        {textServices.findByText('afterwork/about/title', '¿Qué es Heineken Afterwork?')}
      </h1>
      <p className="afterwork__about-text">
        {textServices.findByText(
          'afterwork/about/intro',
          '¿Conoces esa sensación cuando termina la jornada y por fin es momento de desconectar? Eso es lo que celebra Heineken Afterwork.'
        )}
      </p>
      <p className="afterwork__about-text">
        {textServices.findByText(
          'afterwork/about/description',
          'Descubre algunos de los mejores venues de la ciudad y disfruta junto a tus amigos de buena música, grandes conversaciones y, por supuesto, una Heineken bien fría.'
        )}
      </p>
      <p className="afterwork__about-text">
        {textServices.findByText('afterwork/about/highlightQuestion', '¿Lo mejor de todo?')}
        <br />
        {textServices.findByText('afterwork/about/highlightAnswer', 'Los correos pueden esperar.')}
      </p>
      <button
        type="button"
        className="home-v3__button afterwork__cta"
        onClick={() => {
          dlTrackEvent('user_interaction', {
            action: 'click',
            element: '¡quiero participar!',
            link: 'whatsapp',
            section: 'afterwork'
          })
          onCtaClick()
        }}
      >
        {textServices.findByText('afterwork/about/cta', '¡Quiero participar!')}
      </button>
    </section>
  )
}

export default AboutSection
